import { combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import appReducer from './modules/appSlice';
import authReducer from './modules/authSlice';
import contentReducer from './modules/contentSlice';
import localizationReducer from './modules/data/localizationSlice';
import userReducer from './modules/data/userSlice';
import businessAreasReducer from './modules/data/businessAreasSlice';
import objectLanguagesReducer from './modules/data/objectLanguagesSlice';
import foldersReducer from './modules/data/foldersSlice';
import newsReducer from './modules/data/newsSlice';
import objectsReducer from './modules/data/objectsSlice';
import propertiesReducer from './modules/data/propertiesSlice';
import searchReducer from './modules/searchSlice';
import favoritesReducer from './modules/favoritesSlice';
import evaluationsReducer from './modules/evaluationsSlice';
import tagsReducer from './modules/data/tagsSlice';
import doctypesReducer from './modules/data/doctypesSlice';
import campaignReducer from './modules/data/campaignsSlice';

const reducer = combineReducers({
	app: appReducer,
	auth: authReducer,
	content: contentReducer,
	localization: localizationReducer,
	user: userReducer,
	businessAreas: businessAreasReducer,
	objectLanguages: objectLanguagesReducer,
	folders: foldersReducer,
	news: newsReducer,
	objects: objectsReducer,
	properties: propertiesReducer,
	search: searchReducer,
	favorites: favoritesReducer,
	evaluations: evaluationsReducer,
	tags: tagsReducer,
	doctypes: doctypesReducer,
	campaigns: campaignReducer,
});

const store = () => {
	const appStore = configureStore({
		reducer,
		middleware: (getDefaultMiddleware) => {
			if (process.env.NODE_ENV === 'development') {
				return getDefaultMiddleware().concat(logger);
			}
			return getDefaultMiddleware();
		},
	});

	return appStore;
};

export default store();
